import { createSlice } from "@reduxjs/toolkit";

export type UserDetails = {
  userCommArray: string[];
  userCommDisObj: { [commodity: string]: string[] };
  userModuleArray: string[];
  userCanEditArray: string[];
  role_name: string;
  district_level_data: districtLevelData[];
  userEmail: string;
};

export type districtLevelData = {
  BUSINESS_ALLOCATION_THRESHOLD: number | null;
  COMMODITY: string;
  DISTRICT: string;
  ROLE_NAME: string;
  USER_EMAIL_ID: string;
  VOLUME_ALLOCATION_THRESHOLD: number;
};

const initialState: UserDetails = {
  role_name: "",
  userCommArray: [],
  userCommDisObj: {},
  userModuleArray: [],
  userCanEditArray: [],
  district_level_data: [] as districtLevelData[],
  userEmail: "",
};

const userSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    updateUserDetails(state: UserDetails, action) {
      return {
        ...initialState,
        ...action.payload,
      };
    },
  },
});

export const { updateUserDetails } = userSlice.actions;
export default userSlice.reducer;
